import type { ProductImage } from "../type/product";


export type ImageItem = File | ProductImage;
export const getImageSrc = (item: ImageItem) => {
  if (item instanceof File) {
    return URL.createObjectURL(item);
  }

  return item.image;
};